import React from 'react';

const ComingSoon = () => {
    return (
        <div className="coming-soon-card">
            {/* Animated Icon */}
            <div className="coming-soon-icon">
                <i className="fa-regular fa-hourglass-half"></i>
            </div>

            {/* Main Heading */}
            <h2 className="coming-soon-heading">Coming Soon</h2>

            {/* Subtitle */}
            <p className="coming-soon-subtitle">
                We’re working hard to bring you this feature. Stay tuned for updates!
            </p>

            {/* Optional Button */}
            {/* <button className="coming-soon-button" disabled>
                Notify Me
            </button> */}

            {/* Inline CSS */}
            <style jsx>{`
                .coming-soon-card {
                border: 1px solid #e5e7eb;
                background: linear-gradient(to right, #f0fdfa, #ffffff);
                padding: 2rem;
                border-radius: 1.5rem;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                gap: 1.5rem;
                text-align: center;
                box-shadow: 0 10px 15px rgba(0, 0, 0, 0.05);
                animation: fadeIn 0.5s ease-out forwards;
                }

                .coming-soon-icon {
                font-size: 4rem;
                color: #14b8a6;
                animation: pulse 2s infinite;
                }

                .coming-soon-heading {
                font-size: 2rem;
                font-weight: 800;
                color: #1f2937;
                }

                .coming-soon-subtitle {
                font-size: 1rem;
                color: #4b5563;
                max-width: 18rem;
                }

                .coming-soon-button {
                padding: 0.5rem 1.5rem;
                background-color: #14b8a6;
                color: white;
                font-weight: 600;
                border-radius: 9999px;
                box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
                transition: all 0.3s ease;
                cursor: not-allowed;
                }

                .coming-soon-button:hover {
                background-color: #0f766e;
                box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
                }

                /* Animations */
                @keyframes pulse {
                0%, 100% { transform: scale(1); opacity: 1; }
                50% { transform: scale(1.1); opacity: 0.7; }
                }

                @keyframes fadeIn {
                from { opacity: 0; transform: translateY(10px); }
                to { opacity: 1; transform: translateY(0); }
                }
            `}
            </style>
        </div>
    );
};

export default ComingSoon;